import { render, staticRenderFns } from "./Qris.vue?vue&type=template&id=b810beea&lang=html"
import script from "./Qris.vue?vue&type=script&lang=js"
export * from "./Qris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports